var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepratoryDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.398,
    height: 20,
    viewBox: "0 0 17.398 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M20.922,9.7A5.144,5.144,0,0,0,18.83,7.087a6.745,6.745,0,0,1-.752,1.144l0,0c1.364.783,2.156,2.786,1.928,4.87-.378,3.452-1.426,5.818-2.952,6.662a3.9,3.9,0,0,1-3.678-.232l-.142-.069H12.2l-.142.069a3.9,3.9,0,0,1-3.678.232C6.85,18.922,5.8,16.556,5.424,13.1c-.228-2.084.565-4.086,1.928-4.87a2.85,2.85,0,0,1,1.443-.375A6.187,6.187,0,0,1,12.311,9.3l.046.034a13.108,13.108,0,0,0,2.6-.562,4.91,4.91,0,0,0,2.8-2.833,5.213,5.213,0,0,0-.044-4L17.544,1.5l-.468,0a5.251,5.251,0,0,0-5.15,5.913,7.129,7.129,0,0,0-2.347-.861,4.324,4.324,0,0,0-2.907.491A5.119,5.119,0,0,0,4.514,9.7a7.658,7.658,0,0,0-.449,3.554c.434,3.964,1.7,6.63,3.651,7.711a4.273,4.273,0,0,0,2.1.536,6.425,6.425,0,0,0,2.693-.666h.42a5.1,5.1,0,0,0,4.793.13c1.954-1.081,3.217-3.747,3.651-7.711A7.664,7.664,0,0,0,20.922,9.7ZM15.6,3.189a3.871,3.871,0,0,1,1.013-.281,3.883,3.883,0,0,1-3.21,4.927,3.885,3.885,0,0,1,2.2-4.646Z",
    transform: "translate(-4.019 -1.5)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepratoryDiet);
export default __webpack_public_path__ + "static/media/prepratory-diet.a4ed0f3d5b3f18992e2c250a503a295f.svg";
export { ForwardRef as ReactComponent };